import { evmAddress } from './chunk-LJIKHB2F.js';
import { requireForensicParam } from './chunk-O3OIBNP7.js';

// src/spam/index.ts
var TRANSACTION_FLAG_KINDS = [
  "paid_lookalike",
  "poisoning",
  "counterfeit_token",
  "unsolicited_distribution",
  "dust"
];
var TRANSACTION_FLAG_META = {
  paid_lookalike: {
    label: "Paid a lookalike",
    tone: "critical",
    graphEdge: "alert",
    legend: "Payment to a poisoning lookalike"
  },
  poisoning: { label: "Address poisoning", tone: "alert", graphEdge: "demote", legend: "Address-poisoning transfer" },
  counterfeit_token: {
    label: "Counterfeit token",
    tone: "alert",
    graphEdge: "demote",
    legend: "Counterfeit-token transfer"
  },
  unsolicited_distribution: {
    label: "Unsolicited airdrop",
    tone: "alert",
    graphEdge: "demote",
    legend: "Unsolicited airdrop"
  },
  dust: { label: "Dust", tone: "notice", graphEdge: "demote", legend: "Dust transfer" }
};
function edgeFlag(kinds) {
  if (kinds.length === 0) return null;
  let best = null;
  let allDemoted = true;
  for (const kind of kinds) {
    if (!kind) {
      allDemoted = false;
      continue;
    }
    if (best === null || RANK.get(kind) < RANK.get(best)) best = kind;
    if (TRANSACTION_FLAG_META[kind].graphEdge !== "demote") allDemoted = false;
  }
  if (best && TRANSACTION_FLAG_META[best].graphEdge === "alert") return { kind: best, mode: "alert" };
  return best && allDemoted ? { kind: best, mode: "demote" } : null;
}
var RANK = new Map(
  TRANSACTION_FLAG_KINDS.map((kind, index) => [kind, index])
);
function strongestFlag(flags) {
  let best = null;
  for (const flag of flags) {
    if (!flag) continue;
    if (best === null || RANK.get(flag.kind) < RANK.get(best.kind)) best = flag;
  }
  return best;
}
function transactionFlag(kind, reason, label) {
  return { kind, label: label ?? TRANSACTION_FLAG_META[kind].label, reason };
}
var MIN_DISTRIBUTION_RECIPIENTS = requireForensicParam(
  "evm.spam_token",
  "min_batch_recipients"
).default;
var TOKEN_KINDS = /* @__PURE__ */ new Set(["erc20", "nft"]);
var ZERO_ADDRESS = "0x0000000000000000000000000000000000000000";
function unsolicitedDistribution(input) {
  const signer = evmAddress(input.signer);
  const called = evmAddress(input.called);
  const byToken = /* @__PURE__ */ new Map();
  for (const transfer of input.transfers) {
    if (!TOKEN_KINDS.has(String(transfer.kind ?? ""))) continue;
    const from = evmAddress(transfer.from);
    const to = evmAddress(transfer.to);
    const token = evmAddress(transfer.token);
    if (!from || !to || !token) continue;
    if (from === ZERO_ADDRESS || to === ZERO_ADDRESS) continue;
    if (from !== token) continue;
    if (from === signer || to === from) continue;
    byToken.set(token, [...byToken.get(token) ?? [], { ...transfer, from, to, token }]);
  }
  let best = null;
  for (const [token, legs] of byToken) {
    const recipients = new Set(legs.map((leg) => leg.to)).size;
    if (recipients < MIN_DISTRIBUTION_RECIPIENTS) continue;
    if (best !== null && recipients <= best.recipients) continue;
    const self = token === called;
    best = {
      distributor: token,
      recipients,
      legs,
      reason: `This transaction put one contract's own token into ${recipients.toLocaleString("en-US")} different wallets in a single call${self ? ", and that contract is the one it called" : ""}. None of the recipients asked for it and none of them signed anything. That is how an airdrop reaches a wallet, and it is equally how a worthless token buys attention \u2014 the token's name, symbol and amount are all written by whoever deployed it, so read them as a claim the contract is making rather than as a description of what you received.`
    };
  }
  return best;
}

export { MIN_DISTRIBUTION_RECIPIENTS, TRANSACTION_FLAG_KINDS, TRANSACTION_FLAG_META, edgeFlag, strongestFlag, transactionFlag, unsolicitedDistribution };
//# sourceMappingURL=chunk-NJHJJJN3.js.map
//# sourceMappingURL=chunk-NJHJJJN3.js.map